import { Box, ClickAwayListener, Stack } from '@mui/material'
import React from 'react'
import { useNavigate } from 'react-router-dom'
import { FontStyle, navPaddingTop, Slug } from '../constants'

const styles = {
    outer: {
        position: 'fixed',
        top: navPaddingTop,
        right: '10px',
        paddingTop: '10px',
        zIndex: '100',
    },
    container: {
        borderRadius: '10px',
        boxShadow: '0px 4px 8px rgb(0 0 0 / 20%)',
        width: '200px',
    },
    link: {
        ...FontStyle.body,
        height: '100%',
        width: '100%',
        textAlign: 'right',
        px: '1rem',
        py: '1rem',
        backgroundColor: '#fff',
        cursor: 'pointer',
        '&:hover': {
            backgroundColor: '#f5f5f5',
        }
    }
}
const YouPopup = ({ setShow }) => {
    const navigate = useNavigate();
    return (
        <ClickAwayListener onClickAway={() => setShow(false)}>
            <Box sx={styles.outer}>
                <Stack direction='column' sx={styles.container}>
                    <Box sx={{
                        ...styles.link,
                        borderBottom: '1px solid #f5f5f5',
                        borderRadius: '10px 10px 0 0',
                    }}
                        onClick={() => { setShow(false); navigate(Slug.jobResults); }}
                    >My jobs</Box>
                    <Box sx={{
                        ...styles.link,
                        borderBottom: '1px solid #f5f5f5',
                    }}
                        onClick={() => { setShow(false); navigate(Slug.surveyInitial); }}
                    >Search preferences</Box>
                    <Box sx={{
                        ...styles.link,
                        borderRadius: '0 0 10px 10px',
                    }}
                        onClick={() => { setShow(false); navigate(Slug.settings); }}
                    >Account settings</Box>
                </Stack>
            </Box>
        </ClickAwayListener>
    )
}

export default YouPopup